export const VALID_TYPES = ["image/png", "image/svg+xml", "image/webp", "image/jpeg"];
export const MAX_SIZE = 1048576; // 1 MB

export function validateLogoFile(file) {
  if (!VALID_TYPES.includes(file.type)) {
    return { valid: false, error: "Invalid file type" };
  }
  if (file.size > MAX_SIZE) {
    return { valid: false, error: "File must be less than 1mb" };
  }
  return { valid: true, error: null };
}
